import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Typography,
    Grid,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    InputAdornment,
    IconButton,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useLocation, useHistory } from "react-router-dom";
import { formatEventDateSetter, getDateAsPerFormat } from "../../_helpers/reusablefunctions/dateSetter";
import ReusableComponent from "../../components/reusableComponents/reusableInputComponents";
import ReusableMultiComponent from "../../components/reusableComponents/ReusableMultiComponent";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ApiService from "../../_services/ApiService";
import { useSelector } from "react-redux";
import useSnackDispatcher from "../../_helpers/reusablefunctions/snackBarComponent";
import { formSnackbar } from "../../_services/_constants/snackbar.constant";
import noImage from "../../img/no_image.png";
import ReusableMultiCreatableComponent from "../../components/reusableComponents/ReusableMultiCreatableComponent";

const ViewEventManagement = () => {
    const history = useHistory();
    const userData = useSelector((state) => state.userData.userData);
    const { successSnack, errorSnack } = useSnackDispatcher();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData;

    const [tabValue, setTabValue] = useState(0);
    const [eventData, setEventData] = useState([]);
    const [eventDeliverables, setEventDeliverables] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [loader, setLoader] = useState(false);
    const [proposed_amount, setproposed_amount] = useState("");
    const [description, setDescription] = useState("");
    const [errors, setErrors] = useState({});
    const [eventDetail, setEventDetail] = useState();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleProposedAmountChange = (value) => {
        setproposed_amount(value);
        if (errors?.proposed_amount && Number(value) >= 5000) {
            setErrors((prev) => ({ ...prev, proposed_amount: "" }));
        }
    };

    useEffect(() => {
        if (errors?.brand_deliverables && selectedOptions.length > 0) {
            setErrors((prev) => ({ ...prev, brand_deliverables: "" }));
        }
    }, [selectedOptions]);

    function eventviewcall() {
        ApiService.get("brand_event_view", {}, locationEventDetail?.event?.event_id || locationEventDetail?.id)
            .then((res) => {
                if (res?.status == 200 || res?.status == 201) {
                    setEventDetail(res?.data?.data);
                }
            })
            .catch((error) => {
                console.log("event:", error);
            });
    }

    useEffect(() => {
        if (location?.page == "submission") {
            ApiService.get("brand_event_submission_view", { id: locationEventDetail?.id })
                .then((res) => {
                    if (res?.status == 200 || res?.status == 201) {
                        let response = res?.data?.data;
                        setproposed_amount(response[0]?.proposed_amount);
                        setDescription(response[0]?.description);
                        setSelectedOptions(response[0]?.brand_deliverables);
                    }
                })
                .catch((error) => {
                    console.log("event:", error);
                });
            eventviewcall();
        } else {
            eventviewcall();
        }
    }, [location]);

    useEffect(() => {
        ApiService.get("deliverables")
            .then((res) => {
                if (res?.status == 200 || res?.status == 201) {
                    setEventDeliverables(res?.data?.data);
                }
            })
            .catch((error) => {
                console.log("event:", error);
            });
    }, []);

    const parseEventHTML = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        const eventData = [];
        const paragraphs = doc.querySelectorAll("p");

        paragraphs.forEach((p, index) => {
            const dayTitle = p.textContent.trim();
            const ul = p.nextElementSibling;

            if (ul && ul.tagName === "UL") {
                const events = Array.from(ul.querySelectorAll("li"))
                    .map((li) => {
                        const match = li.textContent.match(/^(.*?): (.*?) - (.*?) \| (.*?)$/);
                        if (match) {
                            return {
                                title: match[1].trim(),
                                startTime: match[2].trim(),
                                endTime: match[3].trim(),
                                location: match[4].trim(),
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                eventData.push({ day: dayTitle, events });
            }
        });

        return eventData;
    };

    useEffect(() => {
        if (eventDetail?.EventSchedule) {
            const parsedData = parseEventHTML(eventDetail?.EventSchedule);
            setEventData(parsedData);
        }
    }, [eventDetail]);

    const backClickHistory = () => {
        history.push("/event");
    };

    function validationInputs() {
        let errors = {};
        let isValid = true;

        if (!proposed_amount || Number(proposed_amount) < 5000) {
            errors.proposed_amount = "Proposed amount must be higher than the suggested amount, which is the minimum required.";
            isValid = false;
        }

        if (selectedOptions.length === 0) {
            errors.brand_deliverables = "Please select at least one brand deliverable.";
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    }

    function submitBrandDetail(e) {
        e.preventDefault();
        let isValid = validationInputs();
        let postData = new FormData();
        if (isValid) {
            setLoader(true);
            // const data = selectedOptions.map((delivey) => delivey.id);
            const data = selectedOptions
                .map((item) => {
                    if (item.id) return item.id;

                    if (item.name) return item.name;
                    if (item.label) return item.label;
                    if (item.value) return item.value;

                    if (typeof item === "string") return item;

                    return null;
                })
                .filter(Boolean);
            postData.append("description", description);
            postData.append("brand_deliverables", data.join(","));
            postData.append("proposed_amount", proposed_amount);
            postData.append("event", eventDetail?.id);
            postData.append("user", userData?.id);
            postData.append("suggested_amount", eventDetail?.SuggestedSponsorshipAmount);

            ApiService.post("brand_event", postData)
                .then((res) => {
                    if (res.status == 200 || res.status == 201) {
                        setLoader(false);
                        successSnack(formSnackbar?.profileSuccess?.successEventMessage);
                        history.push("/event");
                    }
                })
                .catch((error) => {
                    setLoader(false);
                    errorSnack(formSnackbar.errors.errorMsg);
                    console.log(error);
                });
        }
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prev) =>
            prev === 0 ? (eventDetail?.event_images?.length || 1) - 1 : prev - 1
        );
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prev) =>
            prev === (eventDetail?.event_images?.length || 1) - 1 ? 0 : prev + 1
        );
    };

    // Count total items for "All" tab
    const getTotalCount = () => {
        let count = 1; // About Event always exists
        if (eventDetail?.event_images?.length) count++;
        if (eventData?.length) count++;
        if (eventDetail?.special_attractions?.length) count++;
        // Add Sponsored & Assistance if exists
        return count;
    };

    return (
        <Box sx={{ backgroundColor: "#f5f5f5", p: 4 }}>
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1, pb: 2 }}>
                <IconButton onClick={backClickHistory} sx={{ p: 0 }}>
                    <ArrowBackIcon />
                </IconButton>
                <Box>
                    <Typography variant="h5" sx={{ fontWeight: "600", color: "#1a1a1a" }}>
                        {eventDetail?.EventName}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666" }}>
                        Connect with sponsors and unlock opportunities to fuel your next big event.
                    </Typography>
                </Box>
            </Box>


            {/* Content Area */}
            <Grid container spacing={3} >

                {/* Left Content */}
                <Grid item xs={12} md={8}>
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ backgroundColor: "white", px: 1, mb: 2, pt: '8px', borderRadius: '8px' }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                sx={{
                                    "& .MuiTab-root": {
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "#666",
                                        minHeight: "36px !important", // force correct height
                                        padding: "0 12px !important", // remove vertical padding
                                        display: "flex",
                                        alignItems: "center",
                                    },

                                    "& .MuiTab-wrapper": {
                                        padding: 0,
                                        margin: 0,
                                        lineHeight: "36px", // text perfectly centered
                                        display: "flex",
                                        alignItems: "center",
                                    },

                                    "& .Mui-selected": {
                                        color: "#fff !important",
                                        backgroundColor: "#ef5350",
                                        borderRadius: "4px",
                                    },

                                    "& .MuiTabs-indicator": {
                                        display: "none",
                                    },
                                }}
                            >
                                <Tab label={`All (${getTotalCount()})`} />
                                <Tab label="About Event" />
                                <Tab label="Event Gallery" />
                                <Tab label="Event Schedule" />
                                <Tab label="Special Attractions" />
                                <Tab label="Sponsored & Assistance" />
                            </Tabs>
                        </Box>
                        {/* About Event Section */}
                        {(tabValue === 0 || tabValue === 1) && (
                            <Card sx={{ mb: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Box display={"flex"} flexDirection="row" gap={2}>
                                        <Box sx={{ mb: 3 }}>
                                            <img
                                                src={eventDetail?.Featured_Banner || noImage}
                                                alt={eventDetail?.EventName}
                                                style={{
                                                    width: "300px",
                                                    height: '300px',
                                                    objectFit: "cover",
                                                    borderRadius: "8px",
                                                }}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: "600", mb: 2, color: " #000000 " }}>
                                                About Event
                                            </Typography>
                                            <Typography
                                                dangerouslySetInnerHTML={{ __html: eventDetail?.AbouttheEvent }}
                                                variant="body2"
                                                sx={{ color: "#454545", fontSize: '16px', lineHeight: 1.6 }}
                                            />
                                        </Box>
                                    </Box>




                                    {/* Event Info */}
                                    <Box sx={{ display: "flex", gap: 4, mb: 3 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <LocationOnIcon sx={{ color: "#F08F21", fontSize: "20px" }} />
                                            <Box>
                                                <Typography variant="caption" sx={{ color: "#838383", display: "block" }}>
                                                    Venue
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontWeight: "500", color: "#323232" }}>
                                                    {eventDetail?.CollegeName}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <EventIcon sx={{ color: "#F08F21", fontSize: "20px" }} />
                                            <Box>
                                                <Typography variant="caption" sx={{ color: "#838383", display: "block" }}>
                                                    Date/Time
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontWeight: "500", color: '#323232' }}>
                                                    {eventDetail?.EventFromDate
                                                        ? formatEventDateSetter(
                                                            eventDetail?.EventFromDate,
                                                            eventDetail?.EventFromTime,
                                                            eventDetail?.EventToDate,
                                                            eventDetail?.EventToTime
                                                        )
                                                        : ""}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Event Description */}

                                </CardContent>
                            </Card>
                        )}

                        {/* Event Gallery Section */}
                        {(tabValue === 0 || tabValue === 2) && eventDetail?.event_images?.length > 0 && (
                            <Card sx={{ mb: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="h6" sx={{ fontWeight: "600", mb: 2, color: '#000000' }}>
                                        Event Gallery
                                    </Typography>

                                    <Box sx={{ position: "relative" }}>
                                        <img
                                            src={eventDetail?.event_images[currentImageIndex]?.EventUploadImage || noImage}
                                            alt="Event"
                                            style={{
                                                width: "100%",
                                                height: "200px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                            }}
                                        />

                                        {/* Navigation Buttons */}
                                        <IconButton
                                            onClick={handlePrevImage}
                                            sx={{
                                                position: "absolute",
                                                left: 16,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                backgroundColor: "white",
                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                            }}
                                        >
                                            <ChevronLeftIcon />
                                        </IconButton>

                                        <IconButton
                                            onClick={handleNextImage}
                                            sx={{
                                                position: "absolute",
                                                right: 16,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                backgroundColor: "white",
                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                            }}
                                        >
                                            <ChevronRightIcon />
                                        </IconButton>

                                        {/* Dots Indicator */}
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                bottom: 16,
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                display: "flex",
                                                gap: 1,
                                            }}
                                        >
                                            {eventDetail?.event_images?.map((_, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: "50%",
                                                        backgroundColor: index === currentImageIndex ? "white" : "rgba(255,255,255,0.5)",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => setCurrentImageIndex(index)}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        )}

                        {/* Event Schedule Section */}
                        {(tabValue === 0 || tabValue === 3) && (
                            <Card sx={{ mb: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="h6" sx={{ fontWeight: "600", mb: 2 }}>
                                        Event Schedule (Day-wise)
                                    </Typography>

                                    {/* Render HTML returned by API */}
                                    <Box
                                        sx={{
                                            "& table": {
                                                width: "100%",
                                                borderCollapse: "collapse",
                                            },
                                            "& td, & th": {
                                                border: "1px solid #ddd",
                                                padding: "8px",
                                            },
                                            "& th": {
                                                fontWeight: 600,
                                                background: "#f5f5f5",
                                            }
                                        }}
                                        dangerouslySetInnerHTML={{ __html: eventDetail?.EventSchedule }}
                                    />
                                </CardContent>
                            </Card>
                        )}

                        {/* Special Attractions Section */}
                        {(tabValue === 0 || tabValue === 4) && eventDetail?.special_attractions?.length > 0 && (
                            <Card sx={{ mb: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="h6" sx={{ fontWeight: "600", mb: 3 }}>
                                        Special Attractions
                                    </Typography>

                                    <Grid container spacing={3}>
                                        {eventDetail?.special_attractions.map((section, sectionIndex) =>
                                            section?.data?.map((attraction, index) => (
                                                <Grid item xs={12} sm={6} md={3} key={`${sectionIndex}-${index}`}>
                                                    <Box>
                                                        <img
                                                            src={attraction?.UploadImage || noImage}
                                                            alt={attraction?.Title}
                                                            style={{
                                                                width: "100%",
                                                                height: "200px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                        <Typography variant="subtitle2" sx={{ fontWeight: "600", mt: 1 }}>
                                                            {attraction?.Title || section?.SACategory}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: "#666", fontSize: "12px" }}>
                                                            {attraction?.ArtistName || attraction?.FromCompany}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            ))
                                        )}
                                    </Grid>
                                </CardContent>
                            </Card>
                        )}

                        {/* Sponsored By Section */}
                        {(tabValue === 0 || tabValue === 5) && (
                            <Card sx={{ mb: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Typography variant="h6" sx={{ fontWeight: "600", mb: 2 }}>
                                        Sponsored By
                                    </Typography>

                                    {eventDetail?.sponsors?.length > 0 ? (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexWrap: "wrap",
                                                gap: 3,
                                                alignItems: "center",
                                            }}
                                        >
                                            {eventDetail?.sponsors.map((sponsor) => (
                                                <Box
                                                    key={sponsor.id}
                                                    sx={{
                                                        width: 100,
                                                        height: 100,
                                                        // border: "1px solid #eee",
                                                        borderRadius: "8px",
                                                        p: 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        // backgroundColor: "#fafafa",
                                                    }}
                                                >
                                                    <img
                                                        src={sponsor.UploadLogo}
                                                        alt={sponsor.SponsorName}
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "100%",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </Box>
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" sx={{ color: "#666" }}>
                                            No sponsors listed yet
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>
                        )}

                    </Box>
                </Grid>

                {/* Right Sidebar - Brand Details */}
                <Grid item xs={12} md={4}>
                    <Box sx={{ width: "100%" }}>
                        <Card sx={{ position: "sticky", top: 20 }}>
                            <CardContent sx={{ p: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: "600", mb: 3 }}>
                                    Brand Details
                                </Typography>

                                <ReusableComponent
                                    type="text"
                                    label="Suggested Sponsorship Amount"
                                    value={eventDetail?.SuggestedSponsorshipAmount}
                                    disabledValue={true}
                                    placeholder="Suggested sponsorship amount"
                                    marginSize="20px"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CurrencyRupeeIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <ReusableComponent
                                    type="numeric"
                                    label="Proposed Amount"
                                    placeholder="Minimum amount INR 5,000"
                                    value={proposed_amount}
                                    onChange={handleProposedAmountChange}
                                    error={!!errors.proposed_amount}
                                    helperText={errors.proposed_amount}
                                    disabledValue={location?.page == "submission"}
                                    marginSize="20px"
                                    requireValue
                                />

                                {/* <ReusableMultiComponent
                                    label="Brand Deliverables"
                                    placeholder='E.g., "Product give away, Stall"'
                                    disabledValue={location?.page == "submission"}
                                    optionLabel="name"
                                    options={eventDeliverables}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    error={!!errors.brand_deliverables}
                                    helperText={errors.brand_deliverables}
                                /> */}

                                <ReusableMultiCreatableComponent
                                    label="Brand Deliverables"
                                    placeholder='E.g., "Product give away, Stall"'
                                    disabledValue={location?.page == "submission"}
                                    optionLabel="name"
                                    options={eventDeliverables}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    error={!!errors.brand_deliverables}
                                    helperText={errors.brand_deliverables}
                                    requireValue
                                />


                                <ReusableComponent
                                    type="text"
                                    label="Brand Description"
                                    rowsCount={4}
                                    multiline={true}
                                    placeholder="A short note...."
                                    value={description}
                                    onChange={setDescription}
                                    disabledValue={location?.page == "submission"}
                                    marginSize="20px"
                                />

                                {location?.page !== "submission" && (
                                    <ReusableButton
                                        variant="contained"
                                        classNames="gn-actionbtn"
                                        children="Submit"
                                        onClick={submitBrandDetail}
                                        loader={loader}
                                        sx={{
                                            width: "100%",
                                            backgroundColor: "#ef5350",
                                            "&:hover": { backgroundColor: "#e53935" },
                                            textTransform: "none",
                                            py: 1.5,
                                        }}
                                    />
                                )}
                            </CardContent>
                        </Card>
                    </Box></Grid>
            </Grid>
        </Box>
    );
};

export default ViewEventManagement;